
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 2h18v13H6V2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 9.5h8M8 13h4m-2.15 5l1.5 2.625a.75.75 0 001.303 0l1.5-2.625h6.097a.75.75 0 00.75-.75v-12a.75.75 0 00-.75-.75H3.75a.75.75 0 00-.75.75v12a.75.75 0 00.75.75h6.1z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    